<template>
  <div ref="target" class="tw-relative tw-z-20 tw-h-12 tw-w-12">
    <button
      class="tw-relative tw-z-30 tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-full tw-bg-white tw-text-primary-grey-700 tw-shadow-md tw-outline-0 -tw-outline-offset-4 tw-outline-primary-grey-300 hover:tw-text-primary-grey-300 focus:tw-outline-2 focus-visible:tw-outline-2 active:tw-shadow-none"
      type="button"
      :data-test-id="props.dataTestId"
      @click="isOpen = !isOpen"
    >
      <span class="tw-sr-only">Account Dropdown</span>
      <ClIconTablerUser />
    </button>
    <!-- Dropdown menu -->
    <div
      v-if="isOpen"
      class="tw-absolute tw-right-[-6px] tw-top-[-6px] tw-z-20 tw-flex tw-min-w-[368px] tw-flex-col tw-rounded tw-border-primary-grey-100 tw-bg-white tw-shadow-md"
      @click="isOpen = false"
    >
      <div
        class="tw-relative tw-flex tw-min-h-[58px] tw-w-full tw-items-center tw-justify-start tw-rounded-t tw-bg-primary-grey-300 tw-p-2 dark:tw-bg-primary-grey-100"
      >
        <span
          class="tw-text-lg tw-font-medium tw-text-white dark:tw-text-primary-grey-700"
        >
          <slot name="title" />
        </span>
      </div>
      <div class="tw-relative tw-p-1 tw-pt-0">
        <ul
          class="tw-mb-0 tw-w-full tw-text-base tw-font-normal tw-text-primary-grey-700"
        >
          <slot name="products"></slot>
        </ul>
      </div>
      <div
        v-if="$slots.appearance"
        class="tw-relative tw-border-t tw-border-t-dorian-gray-50 tw-px-2 tw-py-2 dark:tw-border-t-dorian-gray-100"
      >
        <slot name="appearance"></slot>
      </div>
      <div class="tw-relative tw-p-1 tw-pt-0">
        <ul
          class="tw-mb-0 tw-w-full tw-text-base tw-font-normal tw-text-primary-grey-700"
        >
          <slot name="links"></slot>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { onClickOutside } from "@vueuse/core";

import { ClIconTablerUser } from "../icons";

export interface HeaderDropdownProps {
  dataTestId?: string;
}

const props = withDefaults(defineProps<HeaderDropdownProps>(), {
  dataTestId: "",
});

const isOpen = ref(false);
const target = ref(null);

onClickOutside(target, () => {
  if (isOpen.value) {
    isOpen.value = false;
  }
});
</script>

<style scoped></style>
